module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4r6r9n-68377d79df0bad834ecfce3dd6691d0b.svg";